import { colors } from '../../theme/colors';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
} from "@mui/material";
import React from "react";

const CustomConfirmModel = ({
  title,
  textContent,
  confirmButton,
  open,
  handleClose,
  handleAction,
  id,
  name,
  loading,
  loadingButtonType,
}) => {
  return (
    <Box>
      <Dialog
        open={open}
        onClose={!loading ? handleClose : undefined}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiBackdrop-root": {
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            boxShadow: "none",
          },
        }}
        PaperProps={{
          sx: {
            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle sx={{ color: colors.primary }} id="delete-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            {textContent + " " + name + "?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "1rem", gap: "0.5rem" }}>
          <Button
            variant="outlined"
            sx={{
              backgroundColor: "#fff",
              borderColor: colors.primary,
              color: colors.primary,
              textTransform: "capitalize",
              ":hover": {
                backgroundColor: "#fff",
                borderColor: colors.primary,
              },
            }}
            onClick={handleClose}
            disabled={loading}
          >
            No
          </Button>
          <Button
            className="btn"
            variant="contained"
            onClick={() => handleAction(id)}
            autoFocus
            disabled={loading}
            sx={{
              backgroundColor: colors.primary,
              color: "#fff",
              textTransform: "capitalize",
              ":hover": {
                backgroundColor: colors.primary,
                color: "#fff",
              },
              minWidth: loading ? "120px" : "auto",
            }}
          >
            {loading ? (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {loadingButtonType}
                <CircularProgress
                  size={20}
                  color="inherit"
                  sx={{ marginLeft: 1 }}
                />
              </Box>
            ) : (
              confirmButton
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CustomConfirmModel;
